import React, { useEffect, useState } from 'react';
import { config } from '../../../../../../config';
import axiosApi from '../../../../../../core/interceptor/interceptor';
import { Link, withRouter, useHistory, useParams } from 'react-router-dom';
import { messages } from '../../../../../../messages';
import fileIcon from '../../../../../../assets/file-icon.svg';
import "./AddLead.css";
import CustomSelect from '../../../../../../Util/CustomSelect/CustomSelect';
import { EVENT_STATUS, EVENT_OCCASION, LEAD_STATUS, PAID_TYPE } from '../../../../../../Util/helper';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import AutoPlaceComplete from '../../CreateEvent/AutoPlaceComplete';
import { phoneNumberMask, validateEmail } from '../../../../../../Util/helper';
import backArrow from '../../../../../../assets/arrow-back.svg';
import WarningDialogue from '../../../../../../Util/WarningDialogue'
import sendIcon from '../../../../../../assets/send-white.png';
import trashIcon from '../../../../../../assets/trash-white.png';
import uploadIcon from '../../../../../../assets/upload-white.png';
import Invoice from '../../Invoices/Invoices';
import add from "../../../../../../assets/add-icon.svg";
import { Popup } from 'reactjs-popup';
import DatePicker from 'react-datepicker';

function AddLead() {
  const childFunc = React.useRef(null)
  const id = useParams().id;
  const history = useHistory();
  const [formData, setFormData] = useState({
    title: '',
    start_date_time: null,
    end_date_time: null,
    detail: '',
    type: null,
    paid_type: null,
    ticket_price: 0,
    occasion: '',
    other_occasion: '',
    budget: 0,
    no_of_guest: null,
    venue_id: 0,
    venue_name: '',
    status: 'open',
    captured_date_time: new Date(),
    booking_start_date: '',
    booking_deadline: '',
    client_name: '',
    client_email: '',
    client_phone: '',
    client_address: '',
    reason: '',
  });
  const leadEventsOccasions = [{ id: '', name: 'TBD' }, ...EVENT_OCCASION]
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [venues, setVenues] = useState([]);
  const [docs, setDocs] = useState([]);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popupContent, setPopupContent] = useState({});
  const [openFilePopup, setOpenFilePopup] = useState(false);
  const [savedDocs, setSavedDocs] = useState([]);
  const [showSavedDocs, setShowSavedDocs] = useState(false);
  const [errors, setErrors] = useState({
    title: '',
    image: '',
  });
  const [tab, setTab] = useState('detail');

  const getVenues = () => {
    axiosApi.get(`${config.apiUrl}/web-content/venues/active`)
      .then((res) => {
        if (res && res.data && res.data.data) {
          setVenues([{ id: '', name: 'TBD' }, ...res.data.data]);
        }
      })
  }

  const getDocs = () => {
    axiosApi.get(`${config.apiUrl}/leads/docs/${id}`)
      .then((res) => {
        setDocs(res?.data?.data);
      })
  }

  const getLead = (id) => {
    axiosApi.get(`${config.apiUrl}/leads/${id}`)
      .then((res) => {
        if (res && res.data && res.data.data) {
          const data = res.data.data;
          setFormData((prev) => ({
            ...prev,
            title: data?.title,
            start_date_time: data?.start_date_time ? new Date(data?.start_date_time) : null,
            end_date_time: data?.end_date_time ? new Date(data?.end_date_time) : null,
            detail: data?.detail && data?.detail !== 'null' ? data?.detail : '',
            type: data?.type,
            paid_type: data?.paid_type,
            ticket_price: data?.ticket_price ? data?.ticket_price : 0,
            occasion: data?.occasion,
            other_occasion: data?.other_occasion,
            budget: data?.budget,
            no_of_guest: data?.no_of_guest ? data?.no_of_guest : 0,
            venue_id: data?.venue_id,
            venue_name: data?.event_venue?.name,
            client_name: data?.client_name,
            client_email: data?.client_email,
            client_phone: data?.client_phone,
            client_address: data?.client_address,
            status: data?.status,
            reason: data?.reason,
            lead_created: data?.lead_created ? true : false,
            booking_deadline: data?.booking_deadline ? new Date(data?.booking_deadline) : '',
            booking_start_date: data?.booking_start_date ? new Date(data?.booking_start_date) : '',
          }))
        }
      })
  }
  const handleFormChange = (e) => {
    if (e.target.name === 'venue_id') {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
        venue_name: e.target.venue_name
      }))
    } else if (e.target.name === 'occasion') {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
        other_occasion: ''
      }))
    } else if (e.target.name === 'type') {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
        paid_type: 'free',
        ticket_price: 0,
      }))
    } else if (e.target.name === 'paid_type') {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
        ticket_price: 0,
      }))
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value
      }))
    }
  }

  const handleValidation = () => {
    let errorArr = {};
    let formIsValid = true;
    if (!formData['title']?.trim()) {
      formIsValid = false;
      errorArr["title"] = messages && messages.emptyTitle;
    }

    if (formData.status === 'approved') {
      if (!formData.no_of_guest) {
        formIsValid = false;
        errorArr["no_of_guest"] = messages && messages.emptyNoOfMatch;
      }
      if (formData.no_of_guest && formData.no_of_guest < 1) {
        formIsValid = false;
        errorArr["no_of_guest"] = messages && messages.guestGreaterThanOne;
      }
      if (!formData.start_date_time) {
        formIsValid = false;
        errorArr["start_date_time"] = messages && messages.empty_event_start_time;
      }
      if (!formData.end_date_time) {
        formIsValid = false;
        errorArr["end_date_time"] = messages && messages.empty_event_end_time;
      }

      if (formData.start_date_time && formData.end_date_time && (formData.start_date_time > formData.end_date_time)) {
        formIsValid = false;
        errorArr['start_date_time'] = messages && messages.event_end_time_error;
      }

      if (formData.end_date_time && formData.start_date_time) {
        const start = moment(formData.start_date_time);
        const end = moment(formData.end_date_time);

        if (start.isSameOrAfter(end)) {
          formIsValid = false;
          errorArr['end_date_time'] = messages && messages.event_end_time_same_greator;
        }

      }
      // if (!formData.detail) {
      //   formIsValid = false;
      //   errorArr["detail"] = messages && messages.emptyEventDetail;
      // }
      if (!formData.type) {
        formIsValid = false;
        errorArr["type"] = messages && messages.emptyEventType;
      }

      if (formData.type === 'public' && !formData.paid_type) {
        formIsValid = false;
        errorArr["paid_type"] = messages && messages.emptyField;
      }

      if (formData.type === 'public' && formData.paid_type === 'paid' && !formData.ticket_price) {
        formIsValid = false;
        errorArr["ticket_price"] = messages && messages.emptyField;
      }

      // if (!formData.venue_id) {
      //   formIsValid = false;
      //   errorArr["venue_id"] = messages && messages.emptyField;
      // }
      if (!formData.budget) {
        formIsValid = false;
        errorArr["budget"] = messages && messages.emptyField;
      }
      if (!formData.occasion || formData.occasion === 'TBD') {
        formIsValid = false;
        errorArr["occasion"] = messages && messages.emptyOccasion;
      }
      if (!formData.client_name?.trim()) {
        formIsValid = false;
        errorArr["client_name"] = messages && messages.emptyField;
      }
      if (!formData.client_email?.trim()) {
        formIsValid = false;
        errorArr["client_email"] = messages && messages.emptyField;
      }
      if (formData.client_email && !validateEmail((formData.client_email).trim())) {
        formIsValid = false;
        errorArr["client_email"] = messages && messages.invalidEmail;
      }
      if (!formData.client_phone) {
        formIsValid = false;
        errorArr["client_phone"] = messages && messages.emptyField;
      }
      if (formData.client_phone && formData.client_phone.replace(/\D/g, '').length < 10) {
        formIsValid = false;
        errorArr['client_phone'] = messages && messages.phoneLength;
      }
      if (!formData.client_address?.trim()) {
        formIsValid = false;
        errorArr["client_address"] = messages && messages.emptyField;
      }
      if (formData.status === 'rejected' && !formData.reason) {
        formIsValid = false;
        errorArr["reasonRequired"] = messages && messages.emptyField;
      }
      if (formData.type === 'public' && !formData.booking_start_date) {
        formIsValid = false;
        errorArr['booking_start_date'] = messages && messages.bookingStartErr;
      }

      if (formData.type === 'public' && !formData.booking_deadline) {
        formIsValid = false;
        errorArr['booking_deadline'] = messages && messages.bookingEndErr;
      }
      if (formData.booking_start_date && moment(formData.booking_start_date).format() > moment(formData.start_date_time).format()) {
        formIsValid = false;
        errorArr["booking_start_date"] = messages && messages.bookingStartDateErr;
      }
      if (formData.booking_deadline && moment(formData.booking_deadline).format() > moment(formData.start_date_time).format()) {
        formIsValid = false;
        errorArr["booking_deadline"] = messages && messages.bookingDeadlineErr;
      }
      if (formData.booking_start_date && formData.booking_deadline && moment(formData.booking_start_date).format() > moment(formData.booking_deadline).format()) {
        formIsValid = false;
        errorArr["booking_start_date"] = messages && messages.bookingDateErr;
      }
    }
    setErrors(errorArr);
    return formIsValid;
  }

  const handleSubmit = () => {
    setFormSubmitted(true);
    if (handleValidation() || (formData.status === 'reject' && formData.reason)) {
      if (id) {
        axiosApi.put(`${config.apiUrl}/leads/${id}`, formData)
          .then((res) => {
            history.push('/admin/events/leads');
          })
      } else {
        axiosApi.post(`${config.apiUrl}/leads/create`, formData)
          .then((res) => {
            history.push('/admin/events/leads');
          })
      }
    }
  }

  useEffect(() => {
    handleValidation();
    // eslint-disable-next-line
  }, [formData])

  useEffect(() => {
    if (id) {
      getLead(id);
    }
  }, [id])

  useEffect(() => {
    getVenues();
  }, [])

  useEffect(() => {
    if (tab === 'doc' && id > 0) {
      getDocs(id);
    }
    // eslint-disable-next-line
  }, [tab])

  const getPlace = (place) => {
    if (place?.addressVal) {
      setFormData((prev) => ({
        ...prev,
        client_address: place?.addressVal
      }))
    } else {
      setFormData((prev) => ({
        ...prev,
        client_address: place
      }))
    }
  }

  const onFileChange = (e) => {
    if (e.target.files && e.target.files.length) {
      let data = new FormData();
      data.append('name', e.target.files[0].name);
      data.append('lead_id', id);
      data.append('file', e.target.files[0]);
      data.append('type', 'local');
      data.append('created_by', 'admin');
      axiosApi.post(`${config.apiUrl}/leads/doc`, data)
        .then((res) => {
          const temp = [...docs];
          temp.push(res?.data?.data)
          setDocs(temp);
          setOpenFilePopup(false);
        })
    }
  }

  const handleDelete = (e, data) => {
    e.stopPropagation();
    setOpenWarningPopup(true);
    setPopupContent({
      header: 'Confirm',
      description: 'Are you sure, you want to remove?',
      icon: '',
      type: 'confirm',
      action: () => {
        axiosApi.delete(`${config.apiUrl}/leads/doc/${data?.id}`, { data: { source: data } })
          .then((res) => {
            if (res) {
              getDocs();
              setOpenWarningPopup(false);
            }
          })
          .catch((err) => {
            setOpenWarningPopup(false);
          })
      }
    });
  }

  const getSavedDocs = () => {
    axiosApi.get(`${config.apiUrl}/documents/docs`)
      .then((res) => {
        setSavedDocs(res?.data?.data);
      })
  }

  const handleSavedDocs = () => {
    getSavedDocs();
    setShowSavedDocs(true);
  }

  const savedDoc = (data) => {
    if (data) {
      const payload = {
        doc_name: data?.file_name,
        type: 'saved',
        lead_id: id,
        created_by: 'admin',
      }
      axiosApi.post(`${config.apiUrl}/leads/save-doc`, payload)
        .then((res) => {
          const temp = [...docs];
          temp.push(res?.data?.data)
          setDocs(temp);
          setSavedDocs([]);
          setOpenFilePopup(false);
        })
    }
  }

  const sendDocToClient = (e, doc) => {
    e.stopPropagation();
    setOpenWarningPopup(true);
    setPopupContent({
      header: 'Confirm',
      description: 'Are you sure, you want to send?',
      icon: '',
      type: 'confirm',
      action: () => {
        const data = formData;
        data.doc_name = doc?.doc_name;
        data.type = doc?.type;
        data.doc_id = doc?.id;
        axiosApi.post(`${config.apiUrl}/leads/send-doc`, data)
          .then((res) => {
            if (res) {
              getDocs();
              setOpenWarningPopup(false);
            }
          })
          .catch((err) => {
            setOpenWarningPopup(false);
          })
      }
    });
  }

  const handleUpload = () => {
    setOpenFilePopup(true);
  }
  return (
    <>
      <div className="adminMenuContainer addMenulist mul-admin-container">
        <div className="content-wrapper menu-wrapper">
          <div className="heading-wrapper ns-header-wrapper">
            <button onClick={() => history.push('/admin/events/leads')} className='btn with-icon'> <img src={backArrow} alt="" /> Back to Leads</button>
            <div className="left">
              <h1 className="heading">
                Leads
              </h1>
            </div>
          </div>
          <div className="admin-menu-section-wrapper p0">
            <div className="">
              {id && <div className="ns-tabs-outer">
                <div className="cs-new-tabs cs-new-tabs-add">
                  <ul>
                    <li onClick={() => setTab('detail')} className={`${tab === 'detail' ? 'active' : ''}`}>Event Details</li>
                    <li onClick={() => setTab('doc')} className={`${tab === 'doc' ? 'active' : ''}`}>Documents</li>
                    <li onClick={() => setTab('invoice')} className={`${tab === 'invoice' ? 'active' : ''}`}>Invoice</li>
                  </ul>
                  {tab === 'invoice' && <button className='btn with-icon' onClick={() => childFunc.current()} ><img src={add} />Add Invoice</button>}
                  {tab === 'doc' && <button className='btn with-icon upload-btn' onClick={() => handleUpload()}>
                    <input type="file" onChange={(e) => onFileChange(e)} name="file" id="upload-invoice" accept="image/png, image/jpeg, application/pdf" />
                    <img src={uploadIcon} alt="Upload Icon" />
                    {/* <img src={pencilIcon} alt="" /> */}
                    {/* use above img for edit icon */}
                    Upload Doc
                  </button>}
                </div>
              </div>}

              <div className="mul-events-body mul-events-body-add-lead">
                {tab === 'detail' && <div className="mul-form">
                  <div className="cs-row">
                    <div className="cs-col-12 new-sec-title">
                      <h2>Lead Info</h2>
                    </div>
                    <div className="cs-col-4 mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Event Name<sup>*</sup></label>
                        <input name='title' value={formData?.title} onChange={(e) => handleFormChange(e)} type="text" placeholder='Event Name' />
                        <span className="error">{formSubmitted && errors["title"]}</span>
                      </div>
                    </div>
                    <div className="cs-col-4 mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Event Start Date & Time <sup>*</sup></label>
                        {/* <input type="datetime-local" name='start_date_time' value={moment(formData?.start_date_time).format('YYYY-MM-DDTHH:mm')} onChange={(e) => handleFormChange(e)} placeholder='Select Start Date & time' /> */}

                        <DatePicker
                          selected={formData?.start_date_time ? formData?.start_date_time : ''}
                          onChange={(e) => handleFormChange({
                            target: {
                              name: 'start_date_time',
                              value: e
                            }
                          })}
                          dateFormat="MMMM d, yyyy h:mm aa"
                          showTimeSelect
                          timeIntervals={5}
                        />
                        <span className="error">{formSubmitted && errors["start_date_time"]}</span>
                      </div>
                    </div>
                    <div className="cs-col-4 mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Event End Date & Time <sup>*</sup></label>
                        <DatePicker
                          selected={formData?.end_date_time ? formData?.end_date_time : ''}
                          onChange={(e) => handleFormChange({
                            target: {
                              name: 'end_date_time',
                              value: e
                            }
                          })}
                          dateFormat="MMMM d, yyyy h:mm aa"
                          showTimeSelect
                          timeIntervals={5}
                        />
                        <span className="error">{formSubmitted && errors["end_date_time"]}</span>
                      </div>
                    </div>
                    <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <CustomSelect className="mh-32"
                          uniqueKey={'events-key'}
                          required={true}
                          data={[
                            {
                              id: '',
                              name: 'TBD'
                            },
                            {
                              id: 'public',
                              name: 'Public'
                            },
                            {
                              id: 'private',
                              name: 'Private'
                            }
                          ]}
                          label={'Type'}
                          placeholder={formData.type ? EVENT_STATUS[formData.type] : 'TBD'}
                          onSelect={(e) => e && handleFormChange({
                            target: {
                              name: 'type',
                              value: e.id
                            }
                          })}
                          selector="name"
                        />
                        <span className="error">{formSubmitted && errors["type"]}</span>
                      </div>
                    </div>
                    {formData.type === 'public' && <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <CustomSelect className="mh-32"
                          uniqueKey={'events-key'}
                          required={true}
                          data={[
                            {
                              id: '',
                              name: 'TBD'
                            },
                            {
                              id: 'paid',
                              name: 'Paid'
                            },
                            {
                              id: 'free',
                              name: 'Free'
                            }
                          ]}
                          label={'Paid Type'}
                          placeholder={formData.paid_type ? PAID_TYPE[formData.paid_type] : 'TBD'}
                          onSelect={(e) => e && handleFormChange({
                            target: {
                              name: 'paid_type',
                              value: e.id
                            }
                          })}
                          selector="name"
                        />
                        <span className="error">{formSubmitted && errors["paid_type"]}</span>
                      </div>
                    </div>}
                    {formData.type === 'public' && formData.paid_type === 'paid' && <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Ticket Price <sup>*</sup></label>
                        <NumberFormat
                          placeholder=" "
                          onValueChange={(e) => handleFormChange({ target: { name: 'ticket_price', value: e.floatValue } })}
                          value={formData?.ticket_price}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          allowNegative={false}
                          thousandsGroupStyle={['thousand']}
                          thousandSeparator={true}
                          disabled={false}
                          prefix='$'
                          name="ticket_price"
                          autoComplete="off"
                        />
                        <span className="error">{formSubmitted && errors["ticket_price"]}</span>
                      </div>
                    </div>}
                    <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <CustomSelect className="mh-32"
                          uniqueKey={'events-key'}
                          required={true}
                          data={leadEventsOccasions}
                          label={'Occasion'}
                          placeholder={formData?.occasion ? formData?.occasion : 'TBD'}
                          onSelect={(e) => e && handleFormChange({
                            target: {
                              name: 'occasion',
                              value: e.name
                            }
                          })}
                          selector="name"
                        />
                        <span className="error">{formSubmitted && errors["occasion"]}</span>
                      </div>
                    </div>
                    {formData.occasion === 'Other' && <div className="cs-col-2 tab-half-fluid mob-fluid">
                      {/* hide this field and make venue col to 4 */}
                      <div className="mul-input-field">
                        <label htmlFor="">Other Occasion</label>
                        <input name='other_occasion' value={formData?.other_occasion} onChange={(e) => handleFormChange(e)} type="text" placeholder=' ' />
                        <span className="error">{formSubmitted && errors["budget"]}</span>
                      </div>
                    </div>}
                    <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Budget <sup>*</sup></label>
                        <NumberFormat
                          placeholder=" "
                          onValueChange={(e) => handleFormChange({ target: { name: 'budget', value: e.floatValue } })}
                          value={formData?.budget}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          allowNegative={false}
                          thousandsGroupStyle={['thousand']}
                          thousandSeparator={true}
                          disabled={false}
                          prefix='$'
                          name="budget"
                          autoComplete="off"
                        />
                        <span className="error">{formSubmitted && errors["budget"]}</span>
                      </div>
                    </div>
                    <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Number of {formData.type === 'public' ? 'Tickets' : 'Guests'} <sup>*</sup></label>
                        <input name='no_of_guest' onChange={(e) => handleFormChange(e)} value={formData?.no_of_guest} type="number" placeholder='50' />
                        <span className="error">{formSubmitted && errors["no_of_guest"]}</span>
                      </div>
                    </div>
                    <div className={`cs-col-${formData.occasion === 'Other' ? '2' : '4'} tab-half-fluid mob-fluid`}>
                      <div className="mul-input-field">
                        <CustomSelect
                          className="mh-32"
                          uniqueKey={'sports-key'}
                          required={true}
                          data={venues}
                          label={'Venue'}
                          placeholder={formData?.venue_id && formData?.venue_name ? formData?.venue_name : 'TBD'}
                          onSelect={(e) => e && handleFormChange({
                            target: {
                              name: 'venue_id',
                              value: e.id,
                              venue_name: e.name,
                            }
                          })}
                          selector="name"
                        />
                        <span className="error">{formSubmitted && errors["venue_id"]}</span>
                      </div>
                    </div>
                    {

                      formData.type === 'public' &&
                      <>
                        <div className="cs-col-4 mob-fluid">
                          <div className="mul-input-field">
                            <label htmlFor="">Booking Start Date <sup>*</sup></label>
                            <DatePicker
                              selected={formData?.booking_start_date}
                              onChange={(e) => handleFormChange({
                                target: {
                                  name: 'booking_start_date',
                                  value: e
                                }
                              })}
                            />
                            <span className="error">{formSubmitted && errors["booking_start_date"]}</span>
                          </div>
                        </div>
                        <div className="cs-col-4 mob-fluid">
                          <div className="mul-input-field">
                            <label htmlFor="">Booking Deadline <sup>*</sup></label>
                            <DatePicker
                              selected={formData?.booking_deadline}
                              onChange={(e) => handleFormChange({
                                target: {
                                  name: 'booking_deadline',
                                  value: e
                                }
                              })}
                            />
                            <span className="error">{formSubmitted && errors["booking_deadline"]}</span>
                          </div>
                        </div>
                      </>
                    }
                    <div className="cs-col-12">
                      <div className="mul-input-field">
                        <label htmlFor="">Event Details </label>
                        <textarea onChange={(e) => handleFormChange(e)} name="detail" value={formData?.detail} id="eventDetails"></textarea>
                        {/* <span className="error">{formSubmitted && errors["detail"]}</span> */}
                      </div>
                    </div>

                    <div className="cs-col-12 new-sec-title">
                      <h2>Client Info</h2>
                    </div>
                    <div className="cs-col-3 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Client Name <sup>*</sup></label>
                        <input type="text" name='client_name' onChange={(e) => handleFormChange(e)} value={formData?.client_name} placeholder='' />
                        <span className="error">{formSubmitted && errors["client_name"]}</span>
                      </div>
                    </div>

                    <div className="cs-col-3 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Client Email <sup>*</sup></label>
                        <input name='client_email' onChange={(e) => handleFormChange(e)} value={formData?.client_email} type="email" placeholder='email@example.com' />
                        <span className="error">{formSubmitted && errors["client_email"]}</span>
                      </div>
                    </div>

                    <div className="cs-col-3 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Client Phone <sup>*</sup></label>
                        {/* <input name='client_phone' onChange={(e) => handleFormChange(e)} value={formData?.client_phone} type="Tel" placeholder='+1 234-5678-900' /> */}
                        <NumberFormat format={phoneNumberMask} mask="_" name="client_phone" value={formData?.client_phone} onChange={(e) => handleFormChange(e)} />
                        <span className="error">{formSubmitted && errors["client_phone"]}</span>
                      </div>
                    </div>

                    <div className="cs-col-3 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Client Address <sup>*</sup></label>
                        <AutoPlaceComplete
                          getAddress={getPlace}
                          address={formData?.client_address}
                        />
                        <span className="error">{formSubmitted && errors["client_address"]}</span>
                      </div>
                    </div>


                    <div className="cs-col-12 new-sec-title">
                      <h2>Lead Status</h2>
                    </div>
                    <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <CustomSelect className="mh-32"
                          uniqueKey={'events-key'}
                          required={true}
                          data={[
                            {
                              id: 'open',
                              name: 'Open'
                            },
                            {
                              id: 'in_progress',
                              name: 'In Progress'
                            },
                            {
                              id: 'approved',
                              name: 'Approved'
                            },
                            {
                              id: 'rejected',
                              name: 'Rejected'
                            },
                          ]}
                          placeholder={formData.status ? LEAD_STATUS[formData.status] : 'open'}
                          onSelect={(e) => e && handleFormChange({
                            target: {
                              name: 'status',
                              value: e.id
                            }
                          })}
                          selector="name"
                        />
                      </div>
                    </div>

                    {
                      formData.status === 'rejected' &&
                      <div className="cs-col-12">
                        <div className="mul-input-field">
                          <label htmlFor="">Reason <sup>*</sup></label>
                          <textarea onChange={(e) => handleFormChange(e)} name="reason" value={formData?.reason || ''} id="eventDetails"></textarea>
                          <span className="error">{formSubmitted && errors["reasonRequired"]}</span>
                        </div>
                      </div>
                    }

                    <div className="cs-col-12 p-30">
                      <div className="btn-group btn-group-start">
                        <button onClick={() => handleSubmit()} className="btn btn-pri">
                          Save
                        </button>
                        <Link to="/admin/events/leads" className="btn btn-sec"> Cancel </Link>
                      </div>
                    </div>
                  </div>
                </div >}
                {/**
                 * 
                 * DOC Section
                 * 
                 */}
                {
                  id && tab === 'doc' && <div className="mul-event-docs doc-with-dates">
                    <div className="cs-row">
                      <div className="cs-col-12 mul-doc-cards">
                        {docs.length > 0 && docs.map((doc, i) => {
                          const docUrl = doc.doc_url ? doc.doc_url : '';
                          return <div onClick={() => window.open(docUrl)} className="row-card" key={i}>
                            <div className="row-card-title">
                              <div className="row-card-icon">
                                <img src={fileIcon} alt="File Icon" />
                              </div>
                              <h3>
                                {doc?.doc_name}
                              </h3>
                            </div>
                            <div className="row-card-date">
                              <div className="card-date">
                                <span>Created On</span>
                                <p>{moment(doc?.created_at).format('MMMM Do, YYYY')}</p>
                              </div>
                            </div>
                            <div className="row-card-date">
                              {doc?.is_sent ? <div className="card-date">
                                <span>{doc?.created_by === 'user' ? 'Received on' : 'Last Sent Date'}</span>
                                <p>{moment(doc?.sent_date).format('MM/DD/YYYY')}</p>
                              </div> : ''}
                            </div>
                            <div className="row-card-actions">
                              <div className="btn-group">
                                <button className="btn with-icon" onClick={(e) => sendDocToClient(e, doc)}> <img src={sendIcon} alt="" />Send </button>
                                <button onClick={(e) => handleDelete(e, doc)} className="btn btn-sec with-icon"> <img src={trashIcon} alt="" /> Remove</button>
                                {/* {doc?.is_sent && <p>Last sent time: {doc?.sent_date}</p>} */}
                              </div>
                            </div>
                          </div>
                        })
                        }
                      </div >
                    </div >
                  </div >
                }

                {
                  tab === 'invoice' && <Invoice childFunc={childFunc} type="lead" leadId={id} />
                }
              </div >
            </div >
          </div >
        </div >
      </div >
      <Popup className='upload-popup' open={openFilePopup} closeOnDocumentClick={false}>
        <div className="mul-events-body">
          <span className="close" onClick={() => { setOpenFilePopup(false); setSavedDocs([]); setShowSavedDocs(false); }}>&times;</span>
          <h3>Select document location</h3>
          <div className="">
            <div className="btn-group">
              <label className="btn with-icon upload-btn">
                <input type="file" onChange={(e) => onFileChange(e)} name="file" id="upload-invoice" accept="image/png, image/jpeg, application/pdf" />
                Local Storage
              </label>
              <button className="btn with-icon upload-btn" onClick={() => handleSavedDocs()}>Saved documents</button>
            </div>
          </div>
          <div className={`upload-select-doc ${showSavedDocs ? 'show' : ''}`}>
            <h4>Select from list :</h4>
            {
              showSavedDocs && savedDocs.length ?
                savedDocs.map((doc, i) => {
                  return <div onClick={(e) => savedDoc(doc)} className='select-doc-item'>
                    <span >{doc.title}</span>
                  </div>
                })
                : ''
            }
          </div>
        </div>
      </Popup>
      <WarningDialogue
        isOpen={openWarningPopup}
        header={popupContent.header}
        description={popupContent.description}
        icon={popupContent.icon}
        action={popupContent.action}
        onClose={() => setOpenWarningPopup(false)}
      />
    </>
  )
}
export default withRouter(AddLead);